// Angular
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

// Afidium
import { ProcessingEmailService } from '../services/processing-email.service';

@Injectable()
export class HasEmailDataGuard implements CanActivate {
    constructor (
        private processingEmailService: ProcessingEmailService,
        private router: Router
    ) {}

    public canActivate (): boolean {
        if (this.processingEmailService.form) {
            return true;
        } else {
            this.router.navigate(['/sasha/home']);
            return false;
        }
    }
}